var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k3l-table-container"},[_c('b-table',{attrs:{"striped":"","bordered":"","responsive":"","no-border-collapse":"","items":_vm.getK3lData,"fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }